import React, { useEffect, useState, lazy, createElement } from 'react';
const ACCENT = '#e91e8c';
function Check() {
  return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke={ACCENT} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="mt-1 flex-shrink-0" aria-hidden="true" data-id="element-3">
      <path d="M20 6 9 17l-5-5" data-id="element-4" />
    </svg>;
}
const BENEFITS = ['La técnica completa de FELAR explicada paso a paso', 'Cómo eliminar el reflejo nauseoso con un método sencillo', 'La conexión entre tu garganta y tu suelo pélvico y cómo usarla', 'Los movimientos exactos para que sea una experiencia que él no olvide'];
declare global {
  interface Window {
    checkoutElements?: {
      init: (type: string) => {
        mount: (selector: string) => void;
      };
    };
  }
}
export function OtoOffer() {
  const [secondsLeft, setSecondsLeft] = useState(15 * 60);
  useEffect(() => {
    if (secondsLeft <= 0) return;
    const id = setInterval(() => {
      setSecondsLeft(s => s <= 1 ? 0 : s - 1);
    }, 1000);
    return () => clearInterval(id);
  }, [secondsLeft]);
  // Load and mount the Hotmart Sales Funnel widget (handles the upsell purchase)
  useEffect(() => {
    const SCRIPT_SRC = 'https://checkout.hotmart.com/lib/hotmart-checkout-elements.js';
    const mountWidget = () => {
      try {
        window.checkoutElements?.init('salesFunnel').mount('#hotmart-sales-funnel');
      } catch (e) {
        // no-op if the widget fails to mount
      }
    };
    const existing = document.querySelector<HTMLScriptElement>(`script[src="${SCRIPT_SRC}"]`);
    if (window.checkoutElements) {
      mountWidget();
      return;
    }
    if (existing) {
      existing.addEventListener('load', mountWidget);
      return () => existing.removeEventListener('load', mountWidget);
    }
    const script = document.createElement('script');
    script.src = SCRIPT_SRC;
    script.async = true;
    script.addEventListener('load', mountWidget);
    document.body.appendChild(script);
    return () => script.removeEventListener('load', mountWidget);
  }, []);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');
  const expired = secondsLeft <= 0;
  return <main className="relative w-full min-h-full mx-auto overflow-hidden" style={{
    maxWidth: '480px',
    backgroundColor: '#0a0a0a',
    color: '#ffffff',
    fontFamily: "'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif"
  }} data-id="element-5">
      {/* Abstract soft gradient shapes — decoration only */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-0" data-id="element-6">
        <div className="absolute rounded-full blur-3xl" style={{
        width: '320px',
        height: '320px',
        top: '-80px',
        right: '-120px',
        background: 'radial-gradient(circle, rgba(233,30,140,0.28), transparent 70%)'
      }} data-id="element-7" />
        <div className="absolute rounded-full blur-3xl" style={{
        width: '360px',
        height: '360px',
        top: '40%',
        left: '-160px',
        background: 'radial-gradient(circle, rgba(168,85,247,0.20), transparent 70%)'
      }} data-id="element-8" />
        <div className="absolute rounded-full blur-3xl" style={{
        width: '300px',
        height: '300px',
        bottom: '-100px',
        right: '-100px',
        background: 'radial-gradient(circle, rgba(233,30,140,0.18), transparent 70%)'
      }} data-id="element-9" />
      </div>

      <div className="relative z-10" data-id="element-10">
        {/* 1. URGENCY BAR */}
        <div className="w-full text-center font-bold text-white px-4 py-3" style={{
        backgroundColor: ACCENT,
        fontSize: '13px',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        lineHeight: 1.5
      }} data-id="element-11">
          Oferta de una sola vez — Esta página desaparece cuando la cierres
        </div>

        <div className="px-6 pb-12 pt-8" data-id="element-12">
          {/* 2. COUNTDOWN TIMER */}
          <section className="mx-auto rounded-2xl text-center" style={{
          backgroundColor: '#1a1a1a',
          padding: '24px'
        }} aria-live="polite" data-id="element-13">
            <p className="text-white mb-4" style={{
            fontSize: '14px'
          }} data-id="element-14">
              Esta oferta expira en:
            </p>

            {expired ? <p className="font-bold" style={{
            color: '#ef4444',
            fontSize: '22px'
          }} data-id="element-15">
                Esta oferta ha expirado.
              </p> : <div className="flex items-start justify-center gap-6" data-id="element-16">
                <div className="flex flex-col items-center" data-id="element-17">
                  <span className="font-extrabold leading-none tabular-nums" style={{
                color: ACCENT,
                fontSize: '48px'
              }} data-id="element-18">
                    {mm}
                  </span>
                  <span className="text-white mt-2 uppercase" style={{
                fontSize: '12px',
                letterSpacing: '0.05em'
              }} data-id="element-19">
                    Minutos
                  </span>
                </div>
                <span className="font-extrabold leading-none" style={{
              color: ACCENT,
              fontSize: '48px'
            }} data-id="element-20">
                  :
                </span>
                <div className="flex flex-col items-center" data-id="element-21">
                  <span className="font-extrabold leading-none tabular-nums" style={{
                color: ACCENT,
                fontSize: '48px'
              }} data-id="element-22">
                    {ss}
                  </span>
                  <span className="text-white mt-2 uppercase" style={{
                fontSize: '12px',
                letterSpacing: '0.05em'
              }} data-id="element-23">
                    Segundos
                  </span>
                </div>
              </div>}
          </section>

          {/* 3. HEADLINE */}
          <h1 className="text-center font-bold text-white mt-10" style={{
          fontSize: '32px',
          lineHeight: 1.25
        }} data-id="element-24">
            Espera — tu compra está confirmada, pero esta oferta dura solo
            mientras estás en esta página.
          </h1>

          {/* 4. SUBHEADLINE */}
          <p className="text-center mt-5" style={{
          fontSize: '18px',
          color: '#9ca3af',
          lineHeight: 1.5
        }} data-id="element-25">
            Agrega FELAR a tu experiencia hoy, al precio exclusivo de este
            momento. Cuando salgas, esta oferta desaparece para siempre.
          </p>

          {/* Hero mood image */}
          <img src="https://cdn.magicpatterns.com/uploads/8es1m3KPri4jCxQnwgnSdQ/Captura_de_pantalla_2026-06-20_a_la(s)_9.48.57_p.m.jpg" alt="FELAR — experiencia sensual" className="w-full h-auto mt-8 rounded-2xl" loading="lazy" data-id="element-26" />

          {/* 5. BODY SECTION */}
          <p className="text-center mt-8 text-white" style={{
          fontSize: '16px',
          lineHeight: 1.7
        }} data-id="element-27">
            Acabas de dar el primer paso para fortalecer tu relación. Pero hay
            algo que Beatriz reservó solo para quienes toman acción en este
            momento exacto.
          </p>

          <p className="text-center font-bold text-white mt-8" style={{
          fontSize: '48px',
          letterSpacing: '0.02em'
        }} data-id="element-28">
            FELAR
          </p>
          <p className="text-center mt-2" style={{
          fontSize: '16px',
          color: '#9ca3af',
          lineHeight: 1.6
        }} data-id="element-29">
            La técnica que ellos sueñan. Que pocas mujeres conocen. Que también
            activa tu propio placer.
          </p>

          {/* Product bundle / offer image */}
          <img src="https://cdn.magicpatterns.com/uploads/s514rR9GSgYuvdXPrPF5Zg/Captura_de_pantalla_2026-06-20_a_la(s)_9.48.44_p.m.jpg" alt="Especial de fiestas — FELAR y masterclasses incluidas por sólo $27.9 USD" className="w-full h-auto mt-8 rounded-2xl" loading="lazy" data-id="element-30" />

          {/* 6. BENEFITS LIST */}
          <ul className="mt-10 flex flex-col" style={{
          gap: '8px'
        }} data-id="element-31">
            {BENEFITS.map(benefit => <li key={benefit} className="flex items-start gap-3 text-white" style={{
            fontSize: '16px',
            lineHeight: 2
          }} data-id="element-32">
                <Check data-id="element-33" />
                <span data-id="element-34">{benefit}</span>
              </li>)}
          </ul>

          {/* 7. PRICE BLOCK */}
          <section className="mt-10 rounded-2xl text-center" style={{
          backgroundColor: '#1a1a1a',
          padding: '28px 24px'
        }} data-id="element-35">
            <span className="inline-block rounded-full font-bold text-white" style={{
            backgroundColor: ACCENT,
            fontSize: '12px',
            padding: '6px 14px',
            letterSpacing: '0.05em'
          }} data-id="element-36">
              AHORRAS 43%
            </span>

            <p className="mt-5 line-through" style={{
            fontSize: '20px',
            color: '#6b7280'
          }} data-id="element-37">
              Valor regular: $47
            </p>

            <p className="font-extrabold leading-none mt-2" style={{
            fontSize: '56px',
            color: ACCENT
          }} data-id="element-38">
              $27
            </p>

            <p className="mt-4" style={{
            fontSize: '14px',
            color: '#9ca3af',
            lineHeight: 1.6
          }} data-id="element-39">
              Un solo clic. Sin volver a ingresar tus datos de pago.
            </p>
          </section>

          {/* 8. CTA — HOTMART Sales Funnel Widget (one-click upsell purchase) */}
          <div id="hotmart-sales-funnel" className="mt-6" data-id="element-40" />
        </div>
      </div>
    </main>;
}